import React from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import isBoolean from 'lodash.isboolean';
import isEmpty from 'lodash.isempty';

import useTabCards from 'hooks/use-tab-cards';
import useTabFeatures from 'hooks/use-tab-features';
import useSliderQuotes from 'hooks/use-slider-quotes';
import useDocumentsDownload from 'hooks/use-documents-download';
import useIntersectionObserver from 'hooks/use-intersection-observer';
import useImageGallery from 'hooks/use-image-gallery';

import 'components/lazy-blocks/hero/hero.scss';
import 'components/lazy-blocks/hero-with-image/hero-with-image.scss';
import 'components/lazy-blocks/title-and-logos/title-and-logos.scss';
import 'components/lazy-blocks/features-with-3-items-in-row/features-with-3-items-in-row.scss';
import 'components/lazy-blocks/features-with-4-items/features-with-4-items.scss';
import 'components/lazy-blocks/title-and-large-image/title-and-large-image.scss';
import 'components/lazy-blocks/image-and-text/image-and-text.scss';
import 'components/lazy-blocks/large-image-and-text/large-image-and-text.scss';
import 'components/lazy-blocks/title-and-text/title-and-text.scss';
import 'components/lazy-blocks/cards/cards.scss';
import 'components/lazy-blocks/cards-with-image/cards-with-image.scss';
import 'components/lazy-blocks/tab-features-and-image/tab-features-and-image.scss';
import 'components/lazy-blocks/slider-with-quotes/slider-with-quotes.scss';
import 'components/lazy-blocks/documents-for-download/documents-for-download.scss';
import 'components/lazy-blocks/comprasion-table/comprasion-table.scss';
import 'components/lazy-blocks/image-gallery/image-gallery.scss';
import 'components/lazy-blocks/certification/certification.scss';
import 'components/lazy-blocks/title-with-container/title-with-container.scss';
import RecentArticles from 'components/lazy-blocks/recent-articles';
import HeroWithSubscription from 'components/lazy-blocks/hero-with-subscription';
import HighlightedList from 'components/lazy-blocks/highlighted-list';
import TitleAndVideoHtml from 'components/lazy-blocks/title-and-video-html';
import InstallDiagram from 'components/shared/install-diagram';
import CompleteSystem from 'components/shared/complete-system';
import ComparisonBlock from 'components/lazy-blocks/comparison-block';
import HomeHeroWithVideo from 'components/lazy-blocks/home-hero-with-video';
import HealthCheck from 'components/lazy-blocks/health-check';
import DownloadApplication from 'components/shared/download-application';
import GetQuote from 'components/shared/get-quote';
import HomeBanner from 'components/lazy-blocks/home-banner';
import HomeDashboard from 'components/lazy-blocks/home-dashboard';
import HomeSeamlessSystem from 'components/lazy-blocks/home-seamless-system';
import Testimonials from 'components/shared/testimonials';
import HomeSolutions from 'components/lazy-blocks/home-solutions';
import ImprovedSecurity from 'components/shared/improved-security';
import Products from 'components/shared/products';
import HeroWithLargeImage from 'components/lazy-blocks/hero-with-large-image';
import CompactDownloadApplication from 'components/lazy-blocks/compact-download-application';
import Reasons from 'components/lazy-blocks/reasons';
import MobileAccessDashboard from 'components/lazy-blocks/mobile-access-dashboard';
import Quote from 'components/lazy-blocks/quote';
import FAQ from 'components/shared/faq';
import FaceRecognitionHeroWithAnimation from 'components/lazy-blocks/face-recognition-hero-with-animation';
import TabFeaturesWithAnimation from 'components/lazy-blocks/tab-features-with-animation';
import SectionWithContainer from 'components/lazy-blocks/section-with-container';
import CardsWithReviews from 'components/lazy-blocks/cards-with-reviews';
import HubspotFormWrapper from 'components/lazy-blocks/hubspot-form-wrapper';
import HeroWithForm from 'components/lazy-blocks/hero-with-form';
import SubscribeForm from 'components/lazy-blocks/subscribe-form';
import BannerWithButton from 'components/lazy-blocks/banner-with-button';
import RecentNewsletters from 'components/lazy-blocks/recent-newsletters';
import MediaFrame from 'components/lazy-blocks/MediaFrame';
import RentGpt from 'components/lazy-blocks/RentGPT';
import AnimatedLogos from 'components/lazy-blocks/AnimatedLogos';
import HeroWithMedia from 'components/lazy-blocks/HeroWithMedia';
import HeroSplit from 'components/lazy-blocks/HeroSplit';
import LabelCards from 'components/lazy-blocks/LabelCards';
import CardsWithImage from 'components/lazy-blocks/cards-with-image';
import QuotesSlider from 'components/lazy-blocks/QuotesSlider';
import AnimatedImageGallery from 'components/lazy-blocks/AnimatedImageGallery';
import CustomerReviews from 'components/lazy-blocks/CustomerReviews';
import BookMeeting from 'components/lazy-blocks/BookMeeting';
import RevenueHeroBookMeeting from 'components/lazy-blocks/RevenueHeroBookMeeting';
import Features from 'components/lazy-blocks/Features';
import FeaturesTabs from 'components/lazy-blocks/FeaturesTabs';
import FullPageHero from 'components/lazy-blocks/FullPageHero';
import MediaWithText from 'components/lazy-blocks/MediaWithText';
import CardsList from 'components/lazy-blocks/CardsList';
import EstimateGenerator from 'components/lazy-blocks/EstimateGenerator';
import CallToAction from 'components/lazy-blocks/CallToAction';
import SuccessMessage from 'components/lazy-blocks/SuccessMessage';
import VerticalMediaWithText from 'components/lazy-blocks/VerticalMediaWithText';
import MediaHero from 'components/lazy-blocks/MediaHero';
import ImageAndText from 'components/lazy-blocks/image-and-text';
import HorizontalCarousel from 'components/lazy-blocks/HorizontalCarousel';
import KeyFeatures from 'components/lazy-blocks/KeyFeatures';
import SwiftlaneComparison from 'components/lazy-blocks/SwiftlaneComparison';
import FAQBlock from 'components/lazy-blocks/FAQ';
import CenterImageFeatures from 'components/lazy-blocks/CenterImageFeatures';
import FormBlock from 'components/lazy-blocks/FormBlock';
import StatsTestimonials from 'components/lazy-blocks/StatsTestimonials';
import TabFeaturesAndImage from 'components/lazy-blocks/tab-features-and-image';
import MediaWithTextList from 'components/lazy-blocks/MediaWithTextList';
import Blockquote from 'components/lazy-blocks/Blockquote';
import CardsNew from 'components/lazy-blocks/CardsNew';
import TabsWithContent from 'components/lazy-blocks/TabsWithContent';
import StackCards from 'components/lazy-blocks/StackCards';
import FullScreenSections from 'components/lazy-blocks/FullScreenSections';
import ProductViewerGallery from 'components/lazy-blocks/ProductViewerGallery';
import IconsRow from 'components/lazy-blocks/IconsRow';
import MediaWithGrid from 'components/lazy-blocks/MediaWithGrid';
import OpenMobileApp from 'components/lazy-blocks/OpenMobileApp';
import BookMeetingNew from 'components/lazy-blocks/BookMeetingNew';
import BenefitsSections from 'components/lazy-blocks/BenefitsSections';
import FactSheetsGrid from 'components/lazy-blocks/FactSheetsGrid';
import WalletCampaign from 'components/lazy-blocks/WalletCampaign';
import Logos from 'components/lazy-blocks/Logos';
import IntegrationsRow from 'components/lazy-blocks/IntegrationsRow';

function isBooleanString(string) {
  return string === 'true' || string === 'false';
}

function isJSON(string) {
  if (typeof string !== 'string') return false;
  if (isBooleanString(string)) return false;

  try {
    JSON.parse(string);
    // eslint-disable-next-line
  } catch (error) {
    return false;
  }

  return true;
}

function toCamelCase(string) {
  return string.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', '')
  );
}

function transformValue(value) {
  if (isJSON(value)) {
    const parsedJSON = JSON.parse(value);

    if (Array.isArray(parsedJSON)) return parsedJSON.map((item) => transformProps(item));
    if (typeof parsedJSON === 'object' && parsedJSON !== null) return transformProps(parsedJSON);

    return parsedJSON;
  }

  if (Array.isArray(value)) return value.map((item) => transformProps(item));
  if (typeof value === 'object' && value !== null) return transformProps(value);

  if (isBooleanString(value)) return value === 'true';

  return value;
}

function transformProps(props) {
  const transformedProps = {};

  Object.keys(props).forEach((propName) => {
    const transformedValue = transformValue(props[propName]);
    if (!transformedValue && isEmpty(transformedValue) && !isBoolean(transformedValue)) return;
    transformedProps[toCamelCase(propName)] = transformedValue;
  });

  return transformedProps;
}

const components = {
  homeherowithvideo: HomeHeroWithVideo,
  herowithsubscription: HeroWithSubscription,
  herowithlargeimage: HeroWithLargeImage,
  healthcheck: HealthCheck,
  downloadapplication: DownloadApplication,
  getquote: GetQuote,
  homebanner: HomeBanner,
  homedashboard: HomeDashboard,
  homeseamlesssystem: HomeSeamlessSystem,
  homesolutions: HomeSolutions,
  improvedsecurity: ImprovedSecurity,
  testimonials: Testimonials,
  compactdownloadapplication: CompactDownloadApplication,
  reasons: Reasons,
  mobileaccessdashboard: MobileAccessDashboard,
  products: Products,
  quote: Quote,
  faq: FAQ,
  facerecognitionherowithanimation: FaceRecognitionHeroWithAnimation,
  tabfeatureswithanimation: TabFeaturesWithAnimation,
  recentarticles: RecentArticles,
  highlightedlist: HighlightedList,
  titleandvideohtml: TitleAndVideoHtml,
  installdiagram: InstallDiagram,
  completesystem: CompleteSystem,
  comparisonblock: ComparisonBlock,
  sectionwithcontainer: SectionWithContainer,
  cardswithreviews: CardsWithReviews,
  hubspotform: HubspotFormWrapper,
  herowithform: HeroWithForm,
  subscribeform: SubscribeForm,
  bannerwithbutton: BannerWithButton,
  recentnewsletters: RecentNewsletters,
  mediaframe: MediaFrame,
  rentgpt: RentGpt,
  animatedlogos: AnimatedLogos,
  herowithmedia: HeroWithMedia,
  herosplit: HeroSplit,
  labelcards: LabelCards,
  cardswithimage: CardsWithImage,
  quotesslider: QuotesSlider,
  animatedimagegallery: AnimatedImageGallery,
  customerreviews: CustomerReviews,
  bookmeeting: BookMeeting,
  revenueherobookmeeting: RevenueHeroBookMeeting,
  features: Features,
  featurestabs: FeaturesTabs,
  fullpagehero: FullPageHero,
  mediawithtext: MediaWithText,
  cardslist: CardsList,
  estimategenerator: EstimateGenerator,
  calltoaction: CallToAction,
  successmessage: SuccessMessage,
  verticalmediawithtext: VerticalMediaWithText,
  mediahero: MediaHero,
  imageandtext: ImageAndText,
  horizontalcarousel: HorizontalCarousel,
  keyfeatures: KeyFeatures,
  swiftlanecomparison: SwiftlaneComparison,
  faqblock: FAQBlock,
  centerimagefeatures: CenterImageFeatures,
  formblock: FormBlock,
  statstestimonials: StatsTestimonials,
  tabfeaturesandimage: TabFeaturesAndImage,
  mediawithtextlist: MediaWithTextList,
  blockquote: Blockquote,
  cardsnew: CardsNew,
  tabswithcontent: TabsWithContent,
  stackcards: StackCards,
  fullscreensections: FullScreenSections,
  productviewergallery: ProductViewerGallery,
  iconsrow: IconsRow,
  mediawithgrid: MediaWithGrid,
  openmobileapp: OpenMobileApp,
  bookmeetingnew: BookMeetingNew,
  benefitssections: BenefitsSections,
  factsheetsgrid: FactSheetsGrid,
  walletcampaign: WalletCampaign,
  logos: Logos,
  integrationsrow: IntegrationsRow,
};

export const useLazyBlocks = (content) => {
  useTabCards();
  useTabFeatures();
  useSliderQuotes();
  useDocumentsDownload();
  useImageGallery();
  useIntersectionObserver('.use-intersection-observer', {
    rootMargin: '200px',
  });

  const options = {
    // https://github.com/remarkablemark/html-react-parser#htmlparser2
    // The library does parsing on client side differently from server side
    // it results in having a need of passing htmlparser2 to adjust behavior
    // according to the client side behavior
    htmlparser2: {
      lowerCaseAttributeNames: true,
    },

    replace: (domNode) => {
      if (domNode.type === 'tag') {
        // Gatsby image wrappers in WordPress content contain <source data-srcset> and
        // <img data-main-image data-srcset> elements whose attributes are managed by
        // gatsby-plugin-image's inline hydration script. The static HTML has data-srcset="null"
        // while the React render pass has the real URL, causing hydration mismatch warnings.
        // suppressHydrationWarning tells React to skip diffing these Gatsby-managed attributes.
        if (domNode.name === 'source' && domNode.attribs?.['data-srcset'] !== undefined) {
          const props = attributesToProps(domNode.attribs);
          return <source {...props} suppressHydrationWarning />;
        }
        if (domNode.name === 'img' && domNode.attribs?.['data-main-image'] !== undefined) {
          const props = attributesToProps(domNode.attribs);
          // eslint-disable-next-line jsx-a11y/alt-text
          return <img {...props} suppressHydrationWarning />;
        }

        const Component = components[domNode.name];

        if (!Component) return undefined;

        // Only replace <blockquote> when it's the Blockquote lazy block (has data props or block class).
        // Plain <blockquote><p>...</p></blockquote> (e.g. inside slider-with-quotes) must be left as-is
        // so the inner content is preserved; otherwise we render <Blockquote /> with no text.
        if (domNode.name === 'blockquote') {
          const attrs = domNode.attribs || {};
          const hasBlockquoteBlockMarker =
            attrs['data-text'] != null ||
            attrs['data-author'] != null ||
            (typeof attrs.class === 'string' &&
              attrs.class.includes('wp-block-lazyblock-blockquote'));
          if (!hasBlockquoteBlockMarker) return undefined;
        }

        const props = transformProps(attributesToProps(domNode.attribs));
        const children = domToReact(domNode.children || [], options);

        return <Component {...props}>{children}</Component>;
      }
    },
  };

  const reactedContent = parse(content || '', options);

  return { reactedContent };
};
